import { Icon } from "../components/Icon";
import type { CourseOutline } from "../api/client";

export interface CourseNavProps {
  outline: CourseOutline;
  activeModule?: string | null;
  onSelectModule?: (module: string) => void;
  onNewSession: () => void;
  resetting: boolean;
}

export function CourseNav({ outline, activeModule, onSelectModule, onNewSession, resetting }: CourseNavProps) {
  return (
    <div className="nav">
      <p className="nav__topic-hint">Selecciona un tema para añadirlo a tu consulta.</p>
      <nav className="nav__units" aria-label="Temas del curso">
        {outline.units.map((unit) => (
          <section key={unit.unit} className="nav__unit">
            <h2 className="nav__unit-title">
              <span className="nav__unit-code">U{unit.unit.replace(/[^0-9]/g, "")}</span>
              <span className="nav__unit-name">{unit.title}</span>
            </h2>
            <ul className="nav__modules">
              {unit.modules.map((module) => (
                <li key={module.module}>
                  <button
                    type="button"
                    className={`nav__module ${activeModule === module.module ? "nav__module--active" : ""}`}
                    aria-pressed={activeModule === module.module}
                    onClick={() => onSelectModule?.(module.module)}
                  >
                    <span className="nav__module-code" aria-hidden="true">@</span>
                    <span className="nav__module-title">{module.title}</span>
                  </button>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </nav>
      <footer className="nav__footer">
        <button type="button" className="u-button nav__new-session" onClick={onNewSession} disabled={resetting} title="Borrar cookies y datos locales e iniciar otra conversación">
          <Icon name="refresh" size="0.875rem" />
          {resetting ? "Reiniciando…" : "Nueva sesión"}
        </button>
      </footer>
    </div>
  );
}

export default CourseNav;
